module.exports = __webpack_public_path__ + "static/img/copper.ff0f6428.png";